import {
  AssignedUserType,
  ContactType,
  MerchantAccountStatus,
} from '../../core/constants';
import { StreetAddress } from '../streetAddress/streetAddress';
import { AssignedUser } from '../users/assignedUser';
import { InvoiceItem } from './invoiceItem';

// TODO (jacob): This should be be cleaned up
export class Invoice {
  id: string;
  number: number;
  customerId: string;
  merchantId: string;
  amtDue: number;
  status: string;
  dueDate: Date;
  currencyCode: string;
  taxMagnified: number;
  memo: string;
  reminderFreq: string;
  reminderFreqCustomDays: number;
  remindersOn: boolean;
  terms: string;
  customerReceiptEmail: boolean;
  merchantReceiptEmail: boolean;
  previewed: boolean;
  totalAmtDue: number;
  remainingPayments: number;
  customerEmail: string;
  sentOn: Date;
  invoiceItems: InvoiceItem[];
  saveAsDraft: boolean;
  isInstallment: boolean;

  constructor(m: Partial<Invoice>) {
    this.id = m.id || '';
    this.number = m.number || 0;
    this.customerId = m.customerId || '';
    this.merchantId = m.merchantId || '';
    this.amtDue = m.amtDue || 0;
    this.status = m.status || '';
    this.dueDate = m.dueDate || new Date();
    this.currencyCode = m.currencyCode || '';
    this.taxMagnified = m.taxMagnified || 0;
    this.memo = m.memo || '';
    this.reminderFreq = m.reminderFreq || '';
    this.reminderFreqCustomDays = m.reminderFreqCustomDays || 0;
    this.remindersOn = m.remindersOn || false;
    this.terms = m.terms || '';
    this.customerReceiptEmail = m.customerReceiptEmail || false;
    this.merchantReceiptEmail = m.merchantReceiptEmail || false;
    this.previewed = m.previewed || false;
    this.totalAmtDue = m.totalAmtDue || 0;
    this.remainingPayments = m.remainingPayments || 0;
    this.customerEmail = m.customerEmail || '';
    this.sentOn = m.sentOn || new Date();
    this.invoiceItems = m.invoiceItems || [];
    this.saveAsDraft = m.saveAsDraft || false;
    this.isInstallment = m.isInstallment || false;
  }

  static createEmpty(): Invoice {
    return new Invoice({
      id: '',
      number: 0,
      customerId: '',
      merchantId: '',
      amtDue: 0,
      status: '',
      dueDate: new Date(),
      currencyCode: '',
      taxMagnified: 0,
      memo: '',
      reminderFreq: '',
      reminderFreqCustomDays: 0,
      remindersOn: false,
      terms: '',
      customerReceiptEmail: false,
      merchantReceiptEmail: false,
      totalAmtDue: 0,
      remainingPayments: 0,
      customerEmail: '',
      sentOn: new Date(),
      invoiceItems: [],
      saveAsDraft: false,
      isInstallment: false,
    });
  }
}
